module.exports = __webpack_public_path__ + "img/139.1.382faf99.jpg";